"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CartFlagsService = void 0;
const index_1 = require("../generated-source/api/index");
class CartFlagsService {
    constructor(cart) {
        this.cart = cart;
        this.cartFlags = {
            hasBundleProductCategories: false,
            hasEnergy: false,
            hasEnergyMobileSimNbnBundle: false,
            hasEnergyMobileSimBundle: false,
            hasEnergyNbnBundle: false,
            hasEnergyOnly: false,
            hasMobileSim: false,
            hasMobileSimOnly: false,
            hasMobileSimNbnBundle: false,
            hasNbn: false,
            hasNbnOnly: false,
        };
        this.cartProductCategories = [];
    }
    getEnergyProducts() {
        return this.getCartItemsByProductCategory(index_1.ProductCategory.Energy);
    }
    getMobileProducts() {
        return this.getCartItemsByProductCategory(index_1.ProductCategory.Mobile);
    }
    getNbnProducts() {
        return this.getCartItemsByProductCategory(index_1.ProductCategory.Nbn);
    }
    getCartFlags() {
        var _a, _b;
        if (!((_b = (_a = this.cart) === null || _a === void 0 ? void 0 : _a.cartItems) === null || _b === void 0 ? void 0 : _b.length)) {
            return this.cartFlags;
        }
        [...this.cart.cartItems].forEach(cartItem => {
            var _a;
            /* istanbul ignore else */
            if ((_a = cartItem === null || cartItem === void 0 ? void 0 : cartItem.additionalData) === null || _a === void 0 ? void 0 : _a.productCategory) {
                switch (cartItem.additionalData.productCategory.toLowerCase()) {
                    case index_1.ProductCategory.Energy: {
                        this.cartFlags.hasEnergy = true;
                        this.cartProductCategories.push(index_1.ProductCategory.Energy);
                        break;
                    }
                    case index_1.ProductCategory.Mobile.toLowerCase(): {
                        this.cartFlags.hasMobileSim = true;
                        this.cartProductCategories.push(index_1.ProductCategory.Mobile);
                        break;
                    }
                    case index_1.ProductCategory.Nbn: {
                        this.cartFlags.hasNbn = true;
                        this.cartProductCategories.push(index_1.ProductCategory.Nbn);
                        break;
                    }
                }
            }
        });
        this.cartFlags.hasEnergyOnly = this.hasEnergyOnly();
        this.cartFlags.hasMobileSimOnly = this.hasMobileSimOnly();
        this.cartFlags.hasNbnOnly = this.hasNbnOnly();
        if (!this.cartFlags.hasEnergyOnly && !this.cartFlags.hasNbnOnly && !this.cartFlags.hasMobileSimOnly) {
            this.cartFlags.hasBundleProductCategories = true;
            this.cartFlags.hasEnergyMobileSimNbnBundle = this.hasProductCategory([index_1.ProductCategory.Energy, index_1.ProductCategory.Mobile, index_1.ProductCategory.Nbn]);
            this.cartFlags.hasEnergyNbnBundle = !this.cartFlags.hasMobileSim && this.hasProductCategory([index_1.ProductCategory.Energy, index_1.ProductCategory.Nbn]);
            this.cartFlags.hasEnergyMobileSimBundle = !this.cartFlags.hasNbn && this.hasProductCategory([index_1.ProductCategory.Energy, index_1.ProductCategory.Mobile]);
            this.cartFlags.hasMobileSimNbnBundle = !this.cartFlags.hasEnergy && this.hasProductCategory([index_1.ProductCategory.Mobile, index_1.ProductCategory.Nbn]);
        }
        return this.cartFlags;
    }
    hasProductCategory(productCategories) {
        return [...productCategories].every(_productCategory => this.cartProductCategories.includes(_productCategory));
    }
    getCartItemsByProductCategory(category) {
        if (!this.cart.cartItems) {
            return [];
        }
        return [...this.cart.cartItems].filter(_cartItem => {
            var _a;
            if ((_a = _cartItem.additionalData) === null || _a === void 0 ? void 0 : _a.productCategory) {
                return this.isIdenticalProductCategory(_cartItem.additionalData.productCategory, category);
            }
            return false;
        });
    }
    hasEnergyOnly() {
        return this.cartFlags.hasEnergy && !this.cartFlags.hasNbn && !this.cartFlags.hasMobileSim;
    }
    hasMobileSimOnly() {
        return this.cartFlags.hasMobileSim && !this.cartFlags.hasEnergy && !this.cartFlags.hasNbn;
    }
    hasNbnOnly() {
        return this.cartFlags.hasNbn && !this.cartFlags.hasMobileSim && !this.cartFlags.hasEnergy;
    }
    isIdenticalProductCategory(compareFrom, compareTo) {
        return compareFrom.toLowerCase() === compareTo.toLowerCase();
    }
}
exports.CartFlagsService = CartFlagsService;
//# sourceMappingURL=cart-flags.service.js.map